import { inject, Injectable } from '@angular/core';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import keyBy from 'lodash-es/keyBy';
import { NListingLabel } from './listing-label.cms-config';

@Injectable({
    providedIn: 'root'
})
export class ListingLabelService {
    protected iCmsConfigResource = inject(ICmsConfigResource);

    /**
     * Listing labels styles
     */
    protected styles?: { [value: number]: NListingLabel.ILabelStyle };

    /**
     * Default style
     */
    protected defaultStyle?: NListingLabel.ILabelStyle;

    enabled = false;

    /**
     * Load deps
     */
    async load(): Promise<void> {
        if (!this.styles) {
            const config = (await this.iCmsConfigResource.retrieve({ bareUrl: NListingLabel.CONFIG_ID }, undefined))?.data
                ?.content as NListingLabel.IConfigContent;

            this.defaultStyle = { textColor: config?.textColor || '', bgColor: config?.bgColor || '' };
            this.styles = keyBy(
                (config?.labels || []).map(config => ({ ...this.defaultStyle!, ...config }) as NListingLabel.ILabelStyle),
                'value'
            );

            this.enabled = !!config?.enabled;
        }
    }

    getLabelStyle(value: number): NListingLabel.ILabelStyle | undefined {
        if (!value) {
            return undefined;
        }

        if (!this.styles) {
            throw new Error('Listing label config is not loaded yet');
        }

        return this.styles[value];
    }
}
